import { createApi } from '@reduxjs/toolkit/query/react';
import { z } from 'zod';
import { baseQuery } from './baseQuery';
import { validateResponse } from './validateResponse';

export const ProfessionalsV3StubSchema = z.object({ message: z.string() });
export type ProfessionalsV3Stub = z.infer<typeof ProfessionalsV3StubSchema>;

export const professionalsV3Api = createApi({
    reducerPath: 'professionalsV3Api',
    baseQuery,
    endpoints: (builder) => ({
        getProfessionalsV3: builder.query<ProfessionalsV3Stub, void>({
            query: () => 'api/v3/professionals',
            transformResponse: validateResponse(ProfessionalsV3StubSchema),
        }),
    }),
});

export const { useGetProfessionalsV3Query } = professionalsV3Api;
